<template>
  <v-app id="app">
    <v-dialog
      v-model="registerDialog"
      max-width="800"
      persistent
    >
      <v-stepper v-model="e1">
        <v-stepper-header>
          <v-stepper-step
            :complete="e1 > 1"
            step="1"
            :editable="true"
          >
            Selección de usuario
          </v-stepper-step>

          <v-divider />

          <v-stepper-step
            :complete="e1 > 2"
            step="2"
          >
            Registro <strong>{{ titleType }}</strong>
          </v-stepper-step>
        </v-stepper-header>

        <v-stepper-items>
          <v-stepper-content
            step="1"
            class="text-center"
          >
            <v-radio-group v-model="type">
              <v-container>
                <v-row>
                  <v-col md="6">
                    <v-radio
                      label="Profesor"
                      value="tutor"
                    />
                  </v-col>
                  <v-col md="6">
                    <v-radio
                      label="Padre"
                      value="parent"
                    />
                  </v-col>
                </v-row>
              </v-container>
            </v-radio-group>
            <div class="text-right">
              <v-btn
                class="ma-2"
                text
                color="primary"
                @click="close"
              >
                Cancelar
              </v-btn>
              <v-btn
                class="ma-2"
                text
                color="primary"
                @click="e1 = 2"
              >
                Continuar
              </v-btn>
            </div>
          </v-stepper-content>

          <v-stepper-content step="2">
            <v-container>
              <v-row>
                <v-col>
                  <v-form
                    ref="form"
                  >
                    <v-container>
                        <h3>Datos de usuario</h3>
                      <v-row>

                        <v-col
                          cols="12"
                          sm="6"
                          md="4"
                        >
                          <v-text-field
                            v-model="nickname"
                            label="Nombre de usuario"
                            prepend-icon="mdi-account"
                            :rules="nicknameRules"
                          />
                        </v-col>
                        <v-col
                          cols="12"
                          sm="6"
                          md="4"
                        >
                          <v-text-field
                            v-model="firstname"
                            label="Nombres"
                            prepend-icon="mdi-account"
                            :rules="firstnameRules"
                          />
                        </v-col>
                        <v-col
                          cols="12"
                          sm="6"
                          md="4"
                        >
                          <v-text-field
                            v-model="lastname"
                            label="Apellidos"
                            prepend-icon="mdi-account"
                            :rules="lastnameRules"
                          />
                        </v-col>
                        <v-col
                          cols="12"
                          sm="6"
                          md="4"
                        >
                          <v-text-field
                            v-model="email"
                            label="Correo electrónico"
                            prepend-icon="mdi-email"
                            :rules="emailRules"
                          />
                        </v-col>
                        <v-col
                          cols="12"
                          sm="6"
                          md="4"
                        >
                          <v-text-field
                            v-model="password"
                            label="Contraseña"
                            prepend-icon="mdi-lock"
                            type="password"
                            :rules="passRules"
                          />
                        </v-col>
                        <v-col
                          cols="12"
                          sm="6"
                          md="4"
                        >
                          <v-text-field
                            v-model="password_confirm"
                            label="Confirma Contraseña"
                            prepend-icon="mdi-lock"
                            type="password"
                            :rules="password_confirmRules"
                          />
                        </v-col>
                        <v-col
                          cols="12"
                          sm="6"
                          md="4"
                        >
                          <v-menu
                            ref="menuBirthday"
                            v-model="menuBirthday"
                            :close-on-content-click="false"
                            transition="scale-transition"
                            offset-y
                            min-width="290px"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                v-model="birth_date_computed"
                                label="Fecha de nacimiento"
                                prepend-icon="mdi-cake-variant"
                                readonly
                                v-bind="attrs"
                                v-on="on"
                              />
                            </template>
                            <v-date-picker
                              ref="picker"
                              v-model="birth_date"
                              locale="es"
                              :max="new Date().toISOString().substr(0, 10)"
                              min="1950-01-01"
                              @change="save"
                            />
                          </v-menu>
                        </v-col>
                        <v-col
                          cols="12"
                          sm="6"
                          md="4"
                        >
                          <v-select
                            v-model="country"
                            :items="countryOptions"
                            label="País"
                            :rules="countryRules"
                          />
                        </v-col>
                        <v-col
                          cols="12"
                          sm="6"
                          md="4"
                        >
                          <v-select
                            v-model="region"
                            :items="regionOptions"
                            item-text="name"
                            label="Región/Provincia"
                            :disabled="regionOptions.length < 1"
                            :rules="regionRules"
                          />
                        </v-col>
                      <!-- Only Tutor -->
                      </v-row>
                      <v-row v-if="type === 'tutor'">
                        <h3>Institución Educativa en la que labora</h3>

                        <v-col
                          cols="12"
                          sm="6"
                        >

                          <!-- <v-text-field
                            v-model="institution"
                            label="Institución Educativa en la que labora"
                            prepend-icon="mdi-school-outline"
                            :rules="type === 'tutor' ? institutionRules : []"
                          /> -->
                        </v-col>
                        <v-col
                          cols="12"
                          sm="6"
                        >
                          <v-text-field
                            v-model="school"
                            label="Nombre de institución"
                            prepend-icon="mdi-school"
                            :rules="type === 'tutor' ? schoolRules : []"
                          />
                        </v-col>
                        <v-col
                          cols="12"
                          sm="6"
                        >
                          <v-text-field
                            v-model="phone"
                            label="Teléfono"
                            prepend-icon="mdi-phone"
                            :rules="type === 'tutor' ? phoneRules : []"
                          />
                        </v-col>
                        <v-col
                          cols="12"
                          sm="6"
                        >
                          <v-text-field
                            v-model="email_contact"
                            label="Correo electrónico de contacto"
                            prepend-icon="mdi-card-account-mail"
                            :rules="type === 'tutor' ? email_contactRules : []"
                          />
                        </v-col>
                        <v-col
                          cols="12"
                          sm="6"
                        >
                          <v-text-field
                            v-model="address"
                            label="Dirección"
                            prepend-icon="mdi-map-marker"
                            :rules="type === 'tutor' ? addressRules : []"
                          />
                        </v-col>
                        <v-col
                          cols="12"
                          sm="6"
                        >
                          <v-text-field
                            v-model="district"
                            label="Distrito"
                            prepend-icon="mdi-map"
                            :rules="type === 'tutor' ? districtRules : []"
                          />
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-form>
                </v-col>
              </v-row>
            </v-container>
            <template>
              <v-btn
                class="mb-2"
                color="primary"
                block
                @click="register"
              >
                Crear Cuenta
              </v-btn>
              <v-btn
                class="mb-2 red accent-3"
                block
                @click="close"
              >
                Cancelar
              </v-btn>
              <v-btn
                class="blue darken-1"
                block
                @click="openLoginDialog"
              >
                ¿Ya tienes una cuenta? Inicia sesión
              </v-btn>
            </template>
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    </v-dialog>
  </v-app>
</template>

<script>
  import regions from './data.js'
  export default {
    props: {
      registerDialog: {
        type: Boolean,
      },
      loginDialog: {
        type: Boolean,
      },
      updateLoginDialog: {
        type: Boolean,
      },
    },
    data () {
      return {
        regions,
        regionOptions: [],
        menuBirthday: false,
        showPassword1: false,
        showPassword2: false,
        type: 'tutor',
        login_url:
          'https://us-central1-videojuego-sh.cloudfunctions.net/loginPlayer',
        e1: 1,
        nicknameRules: [v => !!v || 'Usuario es requerido'],
        firstnameRules: [v => !!v || 'Nombre es requerido'],
        lastnameRules: [v => !!v || 'Apellifo es requerido'],
        emailRules: [
          value => !!value || 'Email es requerido.',
          value => (value || '').length <= 50 || 'Max 50 caracteres',
          value => {
            const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            return pattern.test(value) || 'Email invalido.'
          },
        ],
        passRules: [v => !!v || 'Contraseña es requerido'],
        password_confirmRules: [
          v => !!v || 'Confirmar contraseña es requerido',
          v => v === this.password || 'Contraseña no es igual',
        ],
        countryRules: [v => !!v || 'País es requerido'],
        regionRules: [v => !!v || 'Ciudad es requerido'],
        institutionRules: [v => !!v || 'Institución es requerido'],
        schoolRules: [v => !!v || 'Colegio es requerido'],
        phoneRules: [v => !!v || 'Télefono es requerido'],
        email_contactRules: [
          value => !!value || 'Email de contacto es requerido.',
          value => (value || '').length <= 50 || 'Max 50 caracteres',
          value => {
            const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            return pattern.test(value) || 'Email invalido.'
          },
        ],
        addressRules: [v => !!v || 'Dirección es requerido'],
        districtRules: [v => !!v || 'Distrito es requerido'],
        nickname: '',
        firstname: '',
        lastname: '',
        email: '',
        password: '',
        password_confirm: '',
        birth_date: new Date().toISOString().substr(0, 10),
        country: '',
        region: '',
        /* Tutor */
        institution: '',
        school: '',
        phone: '',
        address: '',
        district: '',
        email_contact: '',
        /********/
        currentYear: null,
      }
    },
    computed: {
      titleType () {
        return (this.type === 'tutor') ? 'Profesor' : 'Padre'
      },
      birth_date_computed: {
        get: function () {
          return this.formatDate(this.birth_date)
        },
        set: function (newValue) {
          console.log(newValue)
        },
      },
      countryOptions () {
        return this.regions.map(c => c.countryName)
      },
    },
    watch: {
      menuBirthday (val) {
        val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
      },
      registerDialog (val) {
        this.e1 = 1
        this.type = 'tutor'
      },
      country (val) {
        this.regionOptions = this.regions.filter(c => c.countryName === val).flatMap(r => r.regions)
      },
    },
    methods: {
      close () { this.$emit('updateRegisterDialog', false) },
      save (date) {
        this.$refs.menuBirthday.save(date)
      },
      formatDate (date) {
        if (!date) return null

        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },
      openLoginDialog () {
        this.$emit('updateRegisterDialog', false)
        this.$emit('updateLoginDialog', true)
      },
      register () {
        this.$store.commit('SET_LOADING', true)

        var location = {
          country: this.country,
          region: this.region,
        }
        const dataUser = {
          nickname: this.nickname,
          firstname: this.firstname,
          lastname: this.lastname,
          email: this.email,
          password: this.password,
          birth_date: this.birth_date,
          location,
          institution: this.institution,
          school: this.school,
          phone: this.phone,
          address: this.address,
          district: this.district,
          email_contact: this.email_contact,
          type: this.type,
        }
        if (this.$refs.form.validate()) {
          this.$store.commit('SET_USER_REGISTER', dataUser)
          this.$store.dispatch('REGISTER')
          this.close()
        } else {
          console.log('Faltan datos')
        }
      },
    },
  }
</script>
